import Suggestions from '../showcase/suggestions.json';
import CenterSuggestions from '../showcase/center-suggestions.json';

export const truncateString = (inputString = '', maxLength) => {
  if (!inputString) return '';
  if (inputString.length <= maxLength) {
    return inputString;
  } else {
    return inputString.slice(0, maxLength) + '...';
  }
};

export const getSideSuggestions = (selectedBot) => {
  for (const key in Suggestions) {
    if (selectedBot?.botName?.toLowerCase()?.includes(key?.toLowerCase())) {
      return Suggestions[key];
    }
  }
  return Suggestions['Other'];
};
export const getCenterSuggestions = (selectedBot) => {
  for (const key in CenterSuggestions) {
    if (selectedBot?.botName?.toLowerCase()?.includes(key?.toLowerCase())) {
      return CenterSuggestions[key];
    }
  }
  return CenterSuggestions['Other'];
};

export const TICKET_CANCEL_TEXT = 'Ticket creation has been cancelled. If you need further assistance or have other questions, feel free to ask. I\'m here to help!'